import {useContext, useState} from "react";
import ThemeContext from "../../Shared/Theme/ThemeContext";
import Score, {ScoreData} from "../../Shared/Components/Score";
import Footer from "../../Shared/Components/Footer";
import {FirstAidKitItem} from "../Model/FirstAidKitData";
import {Swiper,SwiperSlide} from "swiper/react";
import 'swiper/swiper.min.css';
import useSound from "use-sound";
import {GameHint} from "../../Quiz/Components/GameHint";

export interface FirstAidKitSummaryProps {
    title: string,
    subtitle: string
    score: ScoreData
    items: [FirstAidKitItem]
    onFinish: () => void
    onCancel: () => void
}

export interface FirstAidKitHint {
    title: string,
    content: string
}

export default function FirstAidKitSummary(props: FirstAidKitSummaryProps) {

    const theme = useContext(ThemeContext)
    const [hint, setHint] = useState<FirstAidKitHint>({title: "", content: ""})
    const [sound] = useSound("sounds/click.mp3")

    const scrollToTop = () => {
        window.scrollBy({ top: 0 })
        const div = document.querySelector('.quiz-hint.top')
        if (div) {
            let position = div.getBoundingClientRect()
            window.scrollTo(position.left, position.top + window.scrollY - 20);
        }
    }

    return <div className={"first-aid-kit summary"} style={{backgroundImage:'url('+theme.backgroundImage+')'}}>

        <h1>{props.title}</h1>
        <GameHint className="top" title={hint.title} text={hint.content}  />
        <div className={"container"}>
            <div className={"content"}>
            <img src={"images/first-aid-kit/aid-opened.png"} alt={"aid"} />

                <Swiper loop={true} centeredSlides={true} slideToClickedSlide={true} slidesPerView={1} spaceBetween={30} onSlideChange={(swiper) => {
                    sound()
                    scrollToTop()
                    let item = props.items[swiper.realIndex]
                    setHint({ title: item.name, content: item.description })
                }} breakpoints={{
                    580: {
                        slidesPerView: 1,
                    },
                    992: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                }}>
                    {props.items.map((item, index) =>
                        <SwiperSlide>
                            <img src={item.photo} alt={item.name} />
                            {item.name}
                        </SwiperSlide>
                    )}
                </Swiper>

            </div>
        </div>

        <Score data={props.score}/>
        <Footer home={props.onCancel}/>
    </div>
}